import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CannedAudioResponseAPI from '../../api/cannedAudioResponse';

const state = {
    records: [],
    uiFlags: {
        fetchingList: false,
        creatingItem: false,
        deletingItem: false,
    },
};

const getters = {
    getCannedAudioResponses(_state) {
        return _state.records;
    },
    getCannedAudioUIFlags(_state) {
        return _state.uiFlags;
    },
};

const actions = {
    getCannedAudioResponses: async function getCannedAudioResponses(
        { commit },
        { searchKey, scope } = {}
    ) {
        commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { fetchingList: true });
        try {
            const response = await CannedAudioResponseAPI.get({ searchKey, scope });
            commit(types.default.SET_CANNED_AUDIO, response.data);
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { fetchingList: false });
        } catch (error) {
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { fetchingList: false });
        }
    },

    createCannedAudioResponse: async function createCannedAudioResponse(
        { commit },
        formData
    ) {
        commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { creatingItem: true });
        try {
            const response = await CannedAudioResponseAPI.create(formData);
            commit(types.default.ADD_CANNED_AUDIO, response.data);
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { creatingItem: false });
            return response.data;
        } catch (error) {
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { creatingItem: false });
            return throwErrorMessage(error);
        }
    },

    deleteCannedAudioResponse: async function deleteCannedAudioResponse(
        { commit },
        id
    ) {
        commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { deletingItem: true });
        try {
            await CannedAudioResponseAPI.delete(id);
            commit(types.default.DELETE_CANNED_AUDIO, id);
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { deletingItem: false });
            return id;
        } catch (error) {
            commit(types.default.SET_CANNED_AUDIO_UI_FLAG, { deletingItem: false });
            return throwErrorMessage(error);
        }
    },
};

const mutations = {
    [types.default.SET_CANNED_AUDIO_UI_FLAG](_state, data) {
        _state.uiFlags = {
            ..._state.uiFlags,
            ...data,
        };
    },

    [types.default.SET_CANNED_AUDIO]: MutationHelpers.set,
    [types.default.ADD_CANNED_AUDIO]: MutationHelpers.create,
    [types.default.DELETE_CANNED_AUDIO]: MutationHelpers.destroy,
};

export default {
    state,
    getters,
    actions,
    mutations,
};
